import { render, staticRenderFns } from "./HistoricalNotesTable.vue?vue&type=template&id=778460fd&scoped=true&"
import script from "./HistoricalNotesTable.vue?vue&type=script&lang=ts&"
export * from "./HistoricalNotesTable.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricalNotesTable.vue?vue&type=style&index=0&id=778460fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778460fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSimpleTable,VTooltip})
